export const data = [
  {
    name: "Capsules",
    price: "$30.6",
    img: require("./images/products/capsules.png").default,
    category: "pills",
  },
  {
    name: "Chair",
    price: "$51.52",
    img: require("./images/products/chair.png").default,
    category: "cream",
  },
  {
    name: "Medicine",
    price: "$24.65",
    img: require("./images/products/capsules.png").default,
    category: "pills",
  },
  {
    name: "Sanitizer",
    price: "$24.05",
    img: require("./images/products/sanitizer.png").default,
    category: "covi-19",
    category: "pills",
  },
  {
    name: "Masks",
    price: "$70",
    img: require("./images/products/masks.png").default,
    category: "cream",
  },
  {
    name: "Microscope",
    price: "$86",
    img: require("./images/products/microscope.png").default,
    category: "cream",
  },
  {
    name: "Tablet",
    price: "$2.5",
    img: require("./images/products/capsules.png").default,
    category: "pills",
  },
  {
    name: "Wood chair",
    price: "$120",
    img: require("./images/products/chair.png").default,
    category: "cream",
  },
  {
    name: "Thermometer",
    price: "$90.26",
    img: require("./images/products/thermometer.png").default,
    category: "covi-19",
  },
  {
    name: "Capsules",
    price: "$30.6",
    img: require("./images/products/capsules.png").default,
    category: "covi-19",
  },
  {
    name: "Masks",
    price: "$5",
    img: require("./images/products/masks.png").default,
    category: "covi-19",
  },
  {
    name: "Microscope",
    price: "$84.12",
    img: require("./images/products/microscope.png").default,
    category: "covi-19",
  },
];
